import { render, staticRenderFns } from "./ErrorList.vue?vue&type=template&id=a5bf78fc&scoped=true&"
import script from "./ErrorList.vue?vue&type=script&lang=ts&"
export * from "./ErrorList.vue?vue&type=script&lang=ts&"
import style0 from "./ErrorList.vue?vue&type=style&index=0&id=a5bf78fc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5bf78fc",
  null
  
)

export default component.exports